import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Contact</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Acasă</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Contact
            </li>
          </ol>
        </nav>
        <div className="container history">
          <div className="row">
            <div className="col-lg-4">
              <h2 className="mb-4">Contact</h2>
              <div className="mb-4 p-4 bg-light rounded">
                <p>Telefon: 0771015511</p>
                <p>Email: oncohem2023@gmail.com</p>
                <p className="mb-1">
                  <a
                    className="navbar-brand"
                    href="https://www.facebook.com/profile.php?id=61557414382971"
                  >
                    <img
                      src="images/facebook.png"
                      width="30"
                      height="30"
                      className="d-inline-block align-top"
                      alt="Facebook"
                    />
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
